(function () {
  var popup = document.getElementById('NewsletterPopup');
  if (!popup) return;

  var panel = popup.querySelector('.newsletter-popup__panel');
  var closeEls = popup.querySelectorAll('[data-newsletter-close]');
  var previouslyFocused = null;

  function lockScroll(locked) {
    var html = document.documentElement;
    if (locked) html.classList.add('newsletter-popup-lock');
    else html.classList.remove('newsletter-popup-lock');
  }

  function focusFirst() {
    var focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length) focusables[0].focus();
    else panel.focus();
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;

    var focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openPopup() {
    if (popup.classList.contains('is-open')) return;

    previouslyFocused = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    setTimeout(focusFirst, 0);

    document.addEventListener('keydown', onKeydown);
  }

  function closePopup() {
    if (!popup.classList.contains('is-open')) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    lockScroll(false);

    document.removeEventListener('keydown', onKeydown);

    if (previouslyFocused && previouslyFocused.focus) {
      previouslyFocused.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
      return;
    }
    trapFocus(e);
  }

  for (var i = 0; i < closeEls.length; i++) {
    closeEls[i].addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    var href = a.getAttribute('href') || '';
    var data = a.getAttribute('data-newsletter-open');

    if (data === 'true' || href === '#newsletter' || href.indexOf('javascript:openNewsletterPopup') === 0) {
      e.preventDefault();
      openPopup();
    }
  });

  window.openNewsletterPopup = openPopup;
  window.closeNewsletterPopup = closePopup;
})();
